import React from "react";
import styled from "styled-components";

import ShopNowButton from "./ShopNowButton";
import {
  FourDots,
  GreenCircleRegular,
  MattressImg,
  ThreeDots,
} from "./Mattress.images";

import { LinkTitle } from "./Mattress.styles";

const Mattress = () => {
  return (
    <MattressContainer>
      <MattressImg />
      <QuiltedCover>
        <Title1>Quilted Cover</Title1>
        <ShopNowButton margin={"50px 0 0 105px"} />
        <GreenCircle1 />
        <VerticalThreeDots1 />
        <HorizontalThreeDots1 />
      </QuiltedCover>
      <EvrbaseUnit>
        <Title2>evrbase Unit</Title2>
        <ShopNowButton margin={"480px 0 0 75px"} />
        <GreenCircle2 />
        <VerticalThreeDots2 />
        <HorizontalFourDots2 />
      </EvrbaseUnit>
      <ComfortLayer>
        <Title3>Comfort Layer</Title3>
        <ShopNowButton margin={"360px 0 0 590px"} />
        <GreenCircle3 />
        <HorizontalThreeDots3 />
        <VerticalFourDots3 />
      </ComfortLayer>
      <SupportLayer>
        <Title4>Support Layer</Title4>
        <ShopNowButton margin={"450px 0 0 480px"} />
        <GreenCircle4 />
        <HorizontalThreeDots4 />
        <VerticalFourDots4 />
      </SupportLayer>
    </MattressContainer>
  );
};

const MattressContainer = styled.div`
  position: relative;
`;

const QuiltedCover = styled.div`
  position: absolute;
`;

const Title1 = styled(LinkTitle)`
  margin-left: 67px;
  margin-top: 20px;
`;

const GreenCircle1 = styled(GreenCircleRegular)`
  margin-left: 229px;
  margin-top: 104px;
`;

const HorizontalThreeDots1 = styled(ThreeDots)`
  margin-left: 150px;
  margin-top: 137px;
`;

const VerticalThreeDots1 = styled(ThreeDots)`
  transform: rotate(90deg);
  margin-left: 90px;
  margin-top: 100px;
`;

const EvrbaseUnit = styled.div`
  position: absolute;
`;

const Title2 = styled(LinkTitle)`
  margin-left: 45px;
  margin-top: 454px;
`;

const GreenCircle2 = styled(GreenCircleRegular)`
  margin-left: 226px;
  margin-top: 338px;
`;

const VerticalThreeDots2 = styled(ThreeDots)`
  transform: rotate(90deg);
  margin-left: 57px;
  margin-top: 397px;
`;

const HorizontalFourDots2 = styled(FourDots)`
  transform: rotate(90deg);
  margin-left: 164px;
  margin-top: 314px;
`;

const ComfortLayer = styled.div`
  position: absolute;
`;

const Title3 = styled(LinkTitle)`
  margin-left: 554px;
  margin-top: 333px;
`;

const GreenCircle3 = styled(GreenCircleRegular)`
  margin-left: 366px;
  margin-top: 180px;
`;

const VerticalFourDots3 = styled(FourDots)`
  margin-left: 512px;
  margin-top: 238px;
`;

const HorizontalThreeDots3 = styled(ThreeDots)`
  margin-left: 430px;
  margin-top: 210px;
`;

const SupportLayer = styled.div`
  position: absolute;
`;

const Title4 = styled(LinkTitle)`
  margin-left: 444px;
  margin-top: 423px;
`;

const GreenCircle4 = styled(GreenCircleRegular)`
  margin-left: 273px;
  margin-top: 270px;
`;

const HorizontalThreeDots4 = styled(ThreeDots)`
  margin-left: 340px;
  margin-top: 300px;
`;

const VerticalFourDots4 = styled(FourDots)`
  margin-left: 408px;
  margin-top: 325px;
`;

export default Mattress;
